import {
  Box,
  GridItem,
  Heading,
  Icon,
  Link,
  SimpleGrid,
  Text,
  VStack,
  Flex,
  useColorModeValue,
} from "@chakra-ui/react";
import { ContactForm } from "./ContactForm";

import { FiPhone } from "react-icons/fi";
import { motion } from "framer-motion";
import { CONTACT_INFO } from "../../data/contact";

const MotionBox = motion(Box);

export const ContactInfo = () => {
  const titleColor = useColorModeValue("gray.800", "white");
  const subtitleColor = useColorModeValue("gray.600", "gray.400");
  const iconBg = useColorModeValue("brand.100", "icon.bg");
  const iconColor = useColorModeValue("brand.500", "icon.svg");
  const textColor = useColorModeValue("brand.500", "brand.200");

  return (
    <SimpleGrid columns={{ base: 1, lg: 12 }} spacing={{ base: 6, lg: 8 }}>
      <GridItem colSpan={{ base: 1, lg: 5 }}>
        <MotionBox
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 } as any}
          h="100%"
        >
          <Flex
            p={{ base: 6, md: 7 }}
            flexDir={"column"}
            align="space-between"
            h="100%"
          >
            <VStack align="start" spacing={5}>
              <Box bg={iconBg} borderRadius="2xl" p={4}>
                <Icon
                  verticalAlign="middle"
                  as={FiPhone as any}
                  boxSize={8}
                  color={iconColor}
                />
              </Box>
              <Heading
                as="h2"
                fontSize={{ base: "2xl", md: "3xl" }}
                color={titleColor}
              >
                راه های ارتباطی با تأمین سرمایه امید
              </Heading>
              <Text color={subtitleColor} lineHeight="tall" mb="20px">
                برای برقراری ارتباط با تأمین سرمایه امید، می‌توانید از مسیرهای
                رسمی زیر استفاده کنید. شماره‌های تماس، ایمیل و فکس به‌صورت
                مستقیم در دسترس قرار گرفته‌اند.
              </Text>
              <VStack align="start" spacing={5}>
                <Link
                  href={CONTACT_INFO.officePhoneHref}
                  _hover={{ textDecoration: "none" }}
                >
                  <Text color={titleColor} fontWeight="bold">
                    تماس با تأمین سرمایه امید
                  </Text>
                  <Text color={textColor} dir="ltr" textAlign="right">
                    {CONTACT_INFO.officePhone}
                  </Text>
                </Link>

                <Link
                  href={CONTACT_INFO.fundsPhoneHref}
                  _hover={{ textDecoration: "none" }}
                >
                  <Text color={titleColor} fontWeight="bold">
                    مرکز تماس صندوق‌های سرمایه‌گذاری
                  </Text>
                  <Text color={textColor} dir="ltr" textAlign="right">
                    {CONTACT_INFO.fundsPhone}
                  </Text>
                </Link>

                <Link
                  href={`mailto:${CONTACT_INFO.email}`}
                  _hover={{ textDecoration: "none" }}
                >
                  <Text color={titleColor} fontWeight="bold">
                    ایمیل
                  </Text>
                  <Text color={textColor}>{CONTACT_INFO.email}</Text>
                </Link>

                <Box>
                  <Text color={titleColor} fontWeight="bold">
                    فکس
                  </Text>
                  <Text color={textColor} dir="ltr" textAlign="right">
                    {CONTACT_INFO.fax}
                  </Text>
                </Box>

                <Box>
                  <Text color={titleColor} fontWeight="bold">
                    کدپستی
                  </Text>
                  <Text color={textColor} dir="ltr" textAlign="right">
                    {CONTACT_INFO.postalCode}
                  </Text>
                </Box>
              </VStack>
            </VStack>
          </Flex>
        </MotionBox>
      </GridItem>
      <GridItem colSpan={{ base: 1, lg: 7 }}>
        <ContactForm />
      </GridItem>
    </SimpleGrid>
  );
};
